import React from 'react'
import { Stack } from 'react-bootstrap'
import { SubscribeForm } from './SubscribeForm'

import './subscribe.scss'

export const SubscribeBlock = () => {
  return (
    <div className="subscribe-form-block-container">
      <Stack gap={4} direction='vertical' className="d-flex justify-content-center align-items-center">
        <div className="title-container">
          <h2 className="title">
            Join Our Community
          </h2>
        </div>
        <SubscribeForm />
      </Stack>
    </div>
  )
}
